import { Navigate } from "react-router";

interface FeatureFlagGateProps {
  children: React.ReactNode;
  isEnabled: boolean;
  redirectTo?: string;
}

/**
 * Component that conditionally renders children based on a feature flag
 * Redirects to specified path if feature flag is disabled
 */
export function FeatureFlagGate({
  children,
  isEnabled,
  redirectTo = "/home",
}: FeatureFlagGateProps) {
  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
